import { Moment } from 'moment';

export enum CPProgramWeekFourStep {
    WhatIsFlexibilityStep = 'what-is-psychological-flexibility',
    DevelopingFlexibilityStep = 'developing-flexibility',
    SeeYourThoughtsStep = 'see-your-thoughts',
    FlexibilityExerciseStep = 'flexibility-exercise',
    FlexibilityPracticeStep = 'flexibility-practice',
    DoItAnywayStep = 'do-it-anyway',
    GratitudeStep = 'practice-gratitude',
    ChekInAboutPracticeStep = 'check-in-about-practice',
}

export enum CPProgramWeekFourSurvey {
    Gratitude = 'week-4-gratitude',
}

export interface ChangeFlexibilityExerciseFieldActionArguments {
    id: number;
    field: string;
    value: string;
}

export interface ChangeFlexibilityPlanFieldActionArguments {
    field: string;
    value: string;
}

export interface FlexibilityHomeworkArea {
    title: string;
    activities: FlexibilityHomeworkActivities[];
}

export interface FlexibilityHomeworkActivities {
    activityTitle: string;
    dateToBePerformed: Moment;
    checkInActionsAnswer: string;
    additionalInfo: string;
    completed: boolean | undefined;
}

export interface ChangeAccomplishedActivityFieldActionArguments {
    areaTitle: string;
    activityTitle: string;
    value: string | boolean;
    field: string;
}

export interface ChangeAccomplishedActivityFeelingActionArguments {
    checkInActionsAnswer: string;
    areaTitle: string;
    activityTitle: string;
}

export interface ProgramFeedback {
    rating: number;
    content: string;
    recommendationProbability: number;
}

export interface ChangeProgramFeedbackFieldActionArguments {
    field: string;
    value: string | number;
}

export interface ContentQuestion {
    id: number;
    text: string;
    answer: string;
}

export interface ChangeFlexibilityPracticeAnswerArguments {
    value: string;
}

export interface OptionsQuestion {
    id: number;
    text: string;
    answers: Answer[];
}

export interface Answer {
    description: string;
    isChosen: boolean;
    additionalAnswer?: string;
}

export interface SurveyQuestionFetched {
    id: number;
    data: SurveyQuestionData;
}

export interface SurveyQuestionData {
    question: string;
    options: string[];
    content: string;
}

export interface SurveyQuestionContentFetched {
    id: number;
    data: SurveyQuestionContentData;
}

export interface SurveyQuestionContentData {
    question: string;
    content: string;
}

export interface SurveyQuestionAnswered {
    question: number;
    data: SurveySelectedAnswers;
}

export interface SurveySelectedAnswers {
    option: string;
    content: string;
}

export interface SurveyAnsweredContentQuestion {
    question: number;
    data: SurveyAnswerContent;
}

export interface SurveyAnswerContent {
    content: string;
}

export interface SurveyAnsweredOptionQuestion {
    question: number;
    data: SurveyAnswerOption;
}

export interface SurveyAnswerOption {
    option: string;
}

export type SurveyQuestion = OptionsQuestion | ContentQuestion;

export interface ContentAnswer {
    id: number;
    answer: string;
}

export interface SelectedAnswer {
    id: number;
    description: string;
    additionalAnswer: string;
    answer?: string;
}

export interface ChangeFlexibilityPlanInputArguments {
    id: number;
    value: string;
}

export interface FlexibilityHomeworkAnswer {
    done: boolean;
    feelings: string[];
    description: string;
    scheduledActivity: number;
}
